<template>
	<div id="august-go-green-promotion">
		<hr class="my-16" />
		<h4 class="font-body text-xl font-medium">August Go Green Promotion</h4>

		<div class="mt-8 space-y-5 font-body text-lg">
			<ul class="li-padding-left space-y-5 pl-5">
				<li>
					Offer valid for new carbar subscribers aged 21+ in NSW, QLD,
					and VIC.
				</li>
				<li>
					Campaign runs from 12:01 AM AEST on 1 August 2025 to 11:59
					PM AEST on 31 August 2025.
				</li>
				<li>
					Only vehicles with $0 upfront fee qualify. Model
					availability may vary.
				</li>
				<li>
					Each eligible subscriber will receive one (1) $100 Chargefox
					voucher after 31 August 2025 via email.
				</li>
				<li>
					Vouchers are non-transferable and not redeemable for cash.
				</li>
				<li>
					Vouchers are valid for three (3) years from the date of
					subscription and must be used within the subscription
					period.
				</li>
				<li>
					Voucher use is subject to Chargefox
					<CarbarLink
						href="https://www.chargefox.com/legal/chargefox-voucher-terms-and-conditions"
						target="_blank"
						text="Voucher Terms and Conditions"
						font-size="text-base"
						class="inline-block"
					/>
					<span>.</span>
				</li>
				<li>Only one subscription per person is eligible.</li>
				<li>
					Swaps are not included. Offer excludes fleet or
					tools-of-trade vehicles.
				</li>
				<li>
					Cannot be combined with other offers, except the
					Refer-a-Friend program.
				</li>
				<li>Standard carbar subscription terms and fees apply.</li>
				<li>
					Carbar reserves the right to verify eligibility and
					disqualify fraudulent claims.
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup lang="ts">
import CarbarLink from '@/components/links/CarbarLink.vue'
</script>
